module.exports = __webpack_public_path__ + "img/radiografie.1096da4f.svg";